import { render } from "./MyFooter.vue?vue&type=template&id=7895495a&scoped=true"
const script = {}

import "./MyFooter.vue?vue&type=style&index=0&id=7895495a&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enpzjpl/zjpl-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7895495a"]])

export default __exports__